import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment.prod';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor(private fb: FormBuilder) {}

  public convertToTitleCase(inputString) {
    return inputString.replace(/\b\w+/g, function(word) {
      // Capitalize the first letter of each word (including hyphenated words)
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }
  public getUuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      // tslint:disable-next-line: no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
     * 
     * @param path 
     * @param obj 
     * @param separator 
     * @returns 
     * 
     * Example Usage:- 
     *  
     * // accessing property path on global scope
        resolveObjectPropByPath("document.body.style.width")
        // or
        resolveObjectPropByPath("style.width", document.body)
  
        // accessing array indexes
        // (someObject has been defined in the question)
        resolveObjectPropByPath("part3.0.size", someObject) // returns '10'
  
        // accessing non-existent properties
        // returns undefined when intermediate properties are not defined:
        resolveObjectPropByPath('properties.that.do.not.exist', {hello:'world'})
  
        // accessing properties with unusual keys by changing the separator
        var obj = { object: { 'a.property.name.with.periods': 42 } }
        resolveObjectPropByPath('object->a.property.name.with.periods', obj, '->') // returns 42
  
        // accessing properties with unusual keys by passing a property name array
        resolveObjectPropByPath(['object', 'a.property.name.with.periods'], obj) // returns 42
     */
  public resolveObjectPropByPath(path, obj = window, separator = '.') {
    if (!!path) {
      const properties = Array.isArray(path) ? path : path.split(separator);
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    } else {
      return obj;
    }
  }

  
  public downloadBlobFile(blobData: any) {
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blobData.blob, blobData.fileName);
    } else {
        const a: any = document.createElement('a');
        a.style = 'display: none';
        const url = window.URL.createObjectURL(blobData.blob);
        a.href = url;
        a.download = blobData.fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
  }

  public getFileExtension(fileName: string): string {
    // tslint:disable-next-line: no-bitwise
    return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
  }

  openBlobFile(blobData: any) {
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blobData.blob, blobData.fileName);
    } else {
      const windowReference = window.open();
      const url = URL.createObjectURL(blobData.blob);
      windowReference.location.href = url;
    }
  };

  public getDateStrWithoutTimeZone(input: Date|string): string {
    if (!input) {
      return null;
    }
    
    const dateM = moment(input);

    if (dateM.isValid())
      return dateM.format('YYYY-MM-DD');

    return null;
  }


}
